const NoHashTagsFilter = {
  name: 'noHashTags',
  fn: (value: string) => {
    if (!value) return ''

    const newvalue = value.toString()
    const regexp = /\#\S+ ?/gi
    return newvalue.replace(regexp, '')
  }
}

export default NoHashTagsFilter
